"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

exports.__esModule = true;
exports.default = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _objectWithoutPropertiesLoose2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutPropertiesLoose"));

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _utils = require("../../utils");

var buttonClassNames = {
  "focus": "button-focus-2aHkR",
  "disabled": "button-disabled-UF4K5",
  "active": "button-active-2mAdF",
  "button": "button-button-3fr3r",
  "text": "button-text-2Jjil",
  "outlined": "button-outlined-3dJXM",
  "contained": "button-contained-pmIp-"
};

var Button = function Button(_ref) {
  var children = _ref.children,
      className = _ref.className,
      _ref$variant = _ref.variant,
      variant = _ref$variant === void 0 ? 'text' : _ref$variant,
      _ref$tag = _ref.tag,
      Tag = _ref$tag === void 0 ? 'button' : _ref$tag,
      restProps = (0, _objectWithoutPropertiesLoose2.default)(_ref, ["children", "className", "variant", "tag"]);
  return _react.default.createElement(Tag, (0, _extends2.default)({
    className: _utils.classNames.use('button', variant, className).from(buttonClassNames)
  }, restProps), children);
};

Button.propTypes = {
  variant: _propTypes.default.oneOf(['text', 'outlined', 'contained'])
};
Button.defaultProps = {
  variant: 'text'
};
var _default = Button;
exports.default = _default;